export const ACCEPTED_FORMATS = ['pdf', 'jpeg', 'jpg'];
export const MAX_FILES_COUNT = 1;
